import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const [ menuOpen, setMenuOpen ] = useState(false);
    const [ mobile, setMobile ] = useState(false);

    const handleMenuClick = () => setMenuOpen(!menuOpen);
    const responsiveMenu = () => {
        if (window.innerWidth <= 960) {
            setMobile(true);
        }
        else setMobile(false);
    };
    const handleLinkClick = () => {
        if (menuOpen) setMenuOpen(false);
    };

    useEffect(() => { responsiveMenu() }, []);
    window.addEventListener('resize', responsiveMenu);

    const menu = (
        <ul className={mobile ? "mobile-menu-active" : "desktop-menu-active"}>
            <li className="menu-item" key={0}>
                <NavLink to="/" className="navbar-link" activeClassName="active-link" onClick={handleLinkClick} exact>
                    About
                </NavLink>
            </li>
            <li className="menu-item" key={1}>
                <NavLink to="/education" className="navbar-link" activeClassName="active-link" onClick={handleLinkClick}>
                    Education
                </NavLink>
            </li>
            <li className="menu-item" key={2}>
                <NavLink to="/experience" className="navbar-link" activeClassName="active-link" onClick={handleLinkClick}>
                    Internships & Research
                </NavLink>
            </li>
            <li className="menu-item" key={3}>
                <NavLink to="/projects" className="navbar-link" activeClassName="active-link" onClick={handleLinkClick}>
                    Projects
                </NavLink>
            </li>
        </ul>
    );

    return (
        <>
            <div className="horizontal-navbar">
                <Link to="/" className="navbar-link">Maria Barbulescu</Link>
                {mobile && (<div className="mobile-menu" onClick={handleMenuClick}>
                    <i className={menuOpen ? "fa fa-times" : "fa fa-bars"} />
                </div>)}
            </div>
            <div className="navbar-container">
                {mobile ? (menuOpen && menu) : menu}
            </div>
        </>
    )
}

export default Navbar;